import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';
import { ReachButton } from '../ReachButton/ReachButton';
import { TextContent } from '../TextContent/TextContent';
import './CustomerSummary.scss';

export interface CustomerSummaryProps {
    image?: IGatsbyImageData;
    imageAlt?: string;
    text: string;
    headline: string;
    industry: string;
    location: string;
    founded: string;
    industryLink: string;
    theme: `white` | `gray` | `dark`;
}

export const CustomerSummary = (props: CustomerSummaryProps) => {
    return (
        <section className={`themed-container customer-summary ${props.theme}`}>
            <div className="kite-container">
                <h2>{props.headline}</h2>
                {props.image && (
                    <GatsbyImage
                        image={props.image}
                        alt={props.imageAlt ? props.imageAlt : ``}
                    />
                )}
                <TextContent
                    node={{
                        field_content_text: {
                            value: props.text,
                        },
                    }}
                />
            </div>
        </section>
    );
};
